/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Androidbeta_Tryagain2Inputs */

const id_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coba Lagi`)
};

const ms_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuba Lagi`)
};

const da_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prøv Igen`)
};

const de_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut versuchen`)
};

const en_us2_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try Again`)
};

const es_es2_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intentar de nuevo`)
};

const es_mx2_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intentar de nuevo`)
};

const fil_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subukan Muli`)
};

const fr_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réessayer`)
};

const it_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riprova`)
};

const hu_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próbáld újra`)
};

const nl_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opnieuw proberen`)
};

const no_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prøv igjen`)
};

const pl_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spróbuj ponownie`)
};

const pt_br2_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try Again`)
};

const pt_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentar novamente`)
};

const ro_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Încearcă din nou`)
};

const fi_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yritä uudelleen`)
};

const sv_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Försök igen`)
};

const vi_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thử lại`)
};

const tr_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekrar Dene`)
};

const cs_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zkusit znovu`)
};

const bg_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опитайте отново`)
};

const ru_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повторить`)
};

const uk_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спробувати ще раз`)
};

const ar_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حاول مرة أخرى`)
};

const hi_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुनः प्रयास करें`)
};

const th_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลองอีกครั้ง`)
};

const ja_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再試行`)
};

const zh_cn2_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try Again`)
};

const zh_hant1_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try Again`)
};

const ko_forms_androidbeta_tryagain2 = /** @type {(inputs: Forms_Androidbeta_Tryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try Again`)
};

/**
* | output |
* | --- |
* | "Try Again" |
*
* @param {Forms_Androidbeta_Tryagain2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_androidbeta_tryagain2 = /** @type {((inputs?: Forms_Androidbeta_Tryagain2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Androidbeta_Tryagain2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_androidbeta_tryagain2(inputs)
	if (locale === "ms") return ms_forms_androidbeta_tryagain2(inputs)
	if (locale === "da") return da_forms_androidbeta_tryagain2(inputs)
	if (locale === "de") return de_forms_androidbeta_tryagain2(inputs)
	if (locale === "en-US") return en_us2_forms_androidbeta_tryagain2(inputs)
	if (locale === "es-ES") return es_es2_forms_androidbeta_tryagain2(inputs)
	if (locale === "es-MX") return es_mx2_forms_androidbeta_tryagain2(inputs)
	if (locale === "fil") return fil_forms_androidbeta_tryagain2(inputs)
	if (locale === "fr") return fr_forms_androidbeta_tryagain2(inputs)
	if (locale === "it") return it_forms_androidbeta_tryagain2(inputs)
	if (locale === "hu") return hu_forms_androidbeta_tryagain2(inputs)
	if (locale === "nl") return nl_forms_androidbeta_tryagain2(inputs)
	if (locale === "no") return no_forms_androidbeta_tryagain2(inputs)
	if (locale === "pl") return pl_forms_androidbeta_tryagain2(inputs)
	if (locale === "pt-BR") return pt_br2_forms_androidbeta_tryagain2(inputs)
	if (locale === "pt") return pt_forms_androidbeta_tryagain2(inputs)
	if (locale === "ro") return ro_forms_androidbeta_tryagain2(inputs)
	if (locale === "fi") return fi_forms_androidbeta_tryagain2(inputs)
	if (locale === "sv") return sv_forms_androidbeta_tryagain2(inputs)
	if (locale === "vi") return vi_forms_androidbeta_tryagain2(inputs)
	if (locale === "tr") return tr_forms_androidbeta_tryagain2(inputs)
	if (locale === "cs") return cs_forms_androidbeta_tryagain2(inputs)
	if (locale === "bg") return bg_forms_androidbeta_tryagain2(inputs)
	if (locale === "ru") return ru_forms_androidbeta_tryagain2(inputs)
	if (locale === "uk") return uk_forms_androidbeta_tryagain2(inputs)
	if (locale === "ar") return ar_forms_androidbeta_tryagain2(inputs)
	if (locale === "hi") return hi_forms_androidbeta_tryagain2(inputs)
	if (locale === "th") return th_forms_androidbeta_tryagain2(inputs)
	if (locale === "ja") return ja_forms_androidbeta_tryagain2(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_androidbeta_tryagain2(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_androidbeta_tryagain2(inputs)
	return ko_forms_androidbeta_tryagain2(inputs)
});
export { forms_androidbeta_tryagain2 as "forms.androidBeta.tryAgain" }